import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { useLoader } from "../context/LoaderContext";
import logo from '../assets/img/Group 2.png';

const shineVariants = {
  initial: { y: "-100%" },
  animate: {
    y: "100%",
    transition: {
      duration: 2.5,
      repeat: Infinity,
      ease: "easeInOut"
    },
  },
};

const Loader = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ position: 'relative', width: '150px', height: '150px' }}>
        <Box
          component="img"
          src={logo}
          alt="Thiran Logo"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            zIndex: 1,
            position: 'relative'
          }}
        />
        <motion.div
          variants={shineVariants}
          initial="initial"
          animate="animate"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background:
              'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0.05) 100%)',
            mixBlendMode: 'screen',
            zIndex: 2
          }}
        />
      </Box>
    </Box>
  );
};

export default Loader;
